import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useRecipeIngredientPaginatedSearch(establishmentId, searchTerm, page, filters, disable) {
    const queryReturnValues = useQuery(
      [
        "paginated-recipe-ingredient-search",
        {
          establishmentId,
          page,
          searchTerm,
          filters
        },
      ],
      inventoryClient.searchRecipesByIngredientPaginated,
      {
        enabled: disable ? false : !!searchTerm,
        refetchOnWindowFocus: false,
      }
    );

    return queryReturnValues;
}

export default useRecipeIngredientPaginatedSearch;
